import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { RightArrowIcon } from '../../../../../assets/icons';
import cardSrc from '../../../../../assets/images/newsCard.png';
import { PageLayout } from '../../../../../components/PageLayout/PageLayout';
import { Tag } from '../../../../../components/Tag/Tag';
import { axiosInstance } from '../../../../../helpers/axios';
import { PATH_DASHBOARD } from '../../../../../routes/RouterConfig';
import { IArticleCard } from '../../../../../types/types';
import styles from './UsefulSection.module.scss';

// один материал «Полезного», отмеченный сотрудником «На главную»
export const UsefulSection = () => {
    const [article, setArticle] = useState<IArticleCard | null>(null);

    useEffect(() => {
        axiosInstance
            .get('/v1/article/top/')
            .then((response) => {
                // 204: отмеченного материала нет, и блок не выводится
                if (response.status === 200) {
                    setArticle(response.data);
                }
            })
            .catch((error) => console.error(error));
    }, []);

    if (!article) {
        return null;
    }
    const link = `/useful/${article.id}`;

    return (
        <section className={styles.usefulsection}>
            <PageLayout>
                <div className={styles.useful}>
                    <h2 className={styles.useful__header}>Полезное</h2>
                    <div className={styles.useful__card}>
                        <Link
                            to={link}
                            className={styles.useful__imagecontainer}
                        >
                            <img
                                className={styles.useful__image}
                                src={article.image ?? cardSrc}
                                alt=""
                            />
                        </Link>
                        <div className={styles.useful__content}>
                            <Tag
                                type="rubric"
                                content={article.rubric.title}
                            />
                            <Link to={link} className={styles.useful__title}>
                                {article.title}
                            </Link>
                            <p className={styles.useful__preview}>
                                {article.preview}
                            </p>
                            <Link to={link} className={styles.useful__read}>
                                Читать
                                <span className={styles.useful__read_icon}>
                                    <RightArrowIcon />
                                </span>
                            </Link>
                        </div>
                    </div>
                    <div className={styles.useful__link}>
                        <Link
                            to={PATH_DASHBOARD.useful}
                            className={styles.useful__link_text}
                        >
                            Все материалы
                        </Link>
                        <RightArrowIcon />
                    </div>
                </div>
            </PageLayout>
        </section>
    );
};
